module.exports = __webpack_public_path__ + "static/Medimage Lois-17-346ed64f2f8f2bef19ec08a535c68a05.jpg";